import moment from 'moment'
import { isEmpty, pickBy } from 'lodash-es'

import { Options } from '@/utils/types/common.d'

// 驼峰转下划线并大写
export const humpToLineUpper = (value: string): string =>
  value.replace(/([A-Z])/g, '_$1').toUpperCase()

// 大写下划线转驼峰
export const upperLineToHump = (value: string) => {
  if (!value) return ''
  return value?.toLowerCase().replace(/_(\w)/g, (all, letter) => letter.toUpperCase())
}

export const copyClipboard = (value: string) => {
  navigator.clipboard.writeText(value).then(
    () => {
      console.log('copy success')
    },
    () => {
      console.log('copy failed')
    }
  )
}

export const getImage = (imageName: string): InstanceType<typeof URL>['href'] =>
  new URL(`../assets/images/${imageName}`, import.meta.url).href

export const getWelcomeImage = (imageName: string): InstanceType<typeof URL>['href'] =>
  new URL(`../assets/images/welcome/${imageName}`, import.meta.url).href

export const changeOption = (
  data: any = [],
  label: string = 'dictName',
  value: string = 'dictCode'
) => {
  const arr: Options[] = []
  data?.forEach((item: any) => {
    const obj: Options = {}
    obj.label = item[label] ? item[label] : item
    obj.value = item[value] ? item[value] : item
    arr.push(obj)
  })
  return arr
}

export const transferCascadeOptions = (
  options: any[],
  labelHandlerFn?: (item: any) => string
): SHIELD2.CascadeOption[] =>
  (options as any[]).map((item) => ({
    label: labelHandlerFn?.(item) || item.name,
    value: item.id,
    ...(typeof item.children !== 'undefined' && item.children?.length
      ? { children: transferCascadeOptions(item.children, labelHandlerFn) }
      : {}),
  }))

export const delay = (duration: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, duration)
  })

export const getPrimaryType = (params: any) => Object.prototype.toString.call(params).slice(8, -1)

export const isFormData = (params: any) => getPrimaryType(params) === 'FormData'

export const isUploadingFileInFormData = (param: any): boolean => {
  if (isFormData(param)) return param.has('file')
  return false
}

export const transfer2ids = (array: any[], idAttribute = 'id') => {
  if (getPrimaryType(array) !== 'Array') return array

  return array.reduce(
    (acc: any, item: any) => ({
      byId: {
        ...acc.byId,
        [item[idAttribute]]: item,
      },
      allIds: [...new Set([...acc.allIds, item[idAttribute]])],
    }),
    { byId: {}, allIds: [] }
  )
}

const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD HH:mm'
export const getNormalDateByFormat = (
  date: moment.MomentInput,
  format: string = DEFAULT_DATE_FORMAT
): string => (date ? moment(date).format(format) : (null as unknown as string))

export const isEmptyFn = (data: any) => !isEmpty(data)

export const isNil = (string: string) => string === undefined || string === null || string === ''

export const holdValuableItems = (data: any) => pickBy(data, isEmptyFn) as any

export const getCookie = (cname: any) => {
  const name = `${cname}=`
  const ca = document.cookie.split(';')
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(name) !== -1) return c.substring(name.length, c.length)
  }
  return ''
}

export const isFirefox = () => {
  const isBrowser = typeof window !== 'undefined'
  const { userAgent } = window.navigator
  return isBrowser && userAgent ? userAgent.match(/firefox\/(\d+)/i) : false
}

export function encodeHTML(html: string) {
  if (!html) return html
  const $div = document.createElement('div')
  // eslint-disable-next-line no-unused-expressions
  typeof $div.textContent !== 'undefined' ? ($div.textContent = html) : ($div.innerText = html)
  return $div.innerHTML
}
